<template>
    <div class="com-item course2-module" :key="index" id="about1">
        <div class="component person-nav">
            <div
                class="van-sticky"
                :style="{
                    backgroundColor: modata.WContent.bgColor || 'transparent',
                    backgroundImage: modata.WContent.bgImg ? 'url(' + modata.WContent.bgImg + ')' : 'none',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    color: modata.WContent.textColor || '#333'
                }"
            >
                <div class="titleModule" v-if="modata.WContent.enTitle || modata.WContent.cnTitle">
                    <titleModule v-bind:modata="modata"></titleModule>
                </div>

                <div class="course2-module__inner viewItem" :style="{'--active-color': modata.WContent.activeColor || '#004ea2'}">
                    <div>
                        <div v-if="swiperOption" class="slideWrap">
                            <swiper ref="mySwiper" :options="swiperOption" @slideChange="onSlideChange">
                                <swiper-slide v-for="(item, idx) in modata.WContent.nav" :key="idx">
                                    <div class="slide-item" :class="{ active: idx === activeIndex }" @click="handToSlide(idx)">
                                        <h3 class="p_title">{{ item.year }}</h3>
                                    </div>
                                </swiper-slide>
                            </swiper>
                        </div>

                        <button class="swipers3_arrow swipers3_arrow-left" @click="handPrev">
                            <i class="el-icon-arrow-left"></i>
                        </button>
                        <button class="swipers3_arrow swipers3_arrow-right" @click="handNext">
                            <i class="el-icon-arrow-right"></i>
                        </button>
                    </div>

                    <div v-if="modata.WContent.detailType == 1" class="HonorList active">
                        <ul class="p_list">
                            <li v-for="(item, idx) in currentList" :key="idx">
                                <div class="honorText">
                                    <p class="honorTitle">{{ item.title || (modata.WContent.nav[activeIndex] && modata.WContent.nav[activeIndex].year) || '' }}</p>
                                    <p class="honorSumm">{{ item.summary }}</p>
                                </div>
                                <div class="honorImg">
                                    <img :src="item.imgUrl" :alt="item.title" :title="item.title">
                                </div>
                            </li>
                            <li v-if="!currentList.length" style="text-align:center; padding: 40px 0; color: #999; list-style: none;">
                                暂无内容,请在右侧编辑"轮播项"中的子列表
                            </li>
                        </ul>
                    </div>

                    <div v-else class="course2-module__markdown ql-editor" v-html="modata.WContent.detailMarkdownHtml"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import titleModule from "@/components/Custom/Title";
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';

export default {
    name: "course2-module",
    components: {
        titleModule,
        swiper,
        swiperSlide
    },
    props: {
        index: {
            type: Number
        },
        type: {
            type: String,
            default: 'preview'
        },
        isactive: {
            type: Boolean,
            default: false
        },
        phoneWidth: {
            type: Number,
            default: 1280
        },
        proportion: {
            type: Number,
            default: 1
        },
        modata: {
            type: Object,
            default: function() {
                return {
                    WName: 'course2',
                    Title: '历程',
                    MID: 19,
                    WID: null,
                    ModuleName: 'course2-module',
                    WContent: {}
                }
            }
        }
    },
    data() {
        return {
            activeIndex: 0,
            realIndex:0,
            swiperOption: null
        }
    },
    computed: {
        // swiperIns() {
        //     return this.$refs.mySwiper ? this.$refs.mySwiper.swiper : null
        // },
        currentList() {
            const nav = this.modata.WContent.nav || []
            const cur = nav[this.activeIndex]
            return (cur && cur.list) || []
        }
    },
    watch: {
        'modata.WContent.detailType'() {
            this.$nextTick(() => this.buildSwiper())
        }
    },
    mounted() {
        this.buildSwiper()
    },
    beforeDestroy() {},
    methods: {
        swiperIns() {
            return this.$refs.mySwiper ? this.$refs.mySwiper.swiper : null
        },
        buildSwiper() {
            const opt = {
                autoplay: false,
                slidesPerView: 6,
                slidesPerGroup: 1,
                observer: true,
                observeParents: true,
                breakpoints: {
                    320: { slidesPerView: 1 },
                    768: { slidesPerView: 2 },
                    1280: { slidesPerView: 4,slidesPerGroup: 1, }
                }
            }
            this.swiperOption = opt
            if (!this.swiperIns()) return
            this.swiperIns().update()
        },
        onSlideChange() {
            if (!this.swiperIns()) return
            this.realIndex = this.swiperIns().realIndex || 0;
            this.activeIndex = this.swiperIns().realIndex || 0
        },
        // handSlide(index){
        //     this.activeIndex = index || 0
        // },
        handPrev() {
             this.activeIndex=this.activeIndex<=0?0:this.activeIndex-1;
            if (this.swiperIns() && (this.realIndex-1)>=this.activeIndex){
                this.swiperIns().slidePrev()
            } 
        },
        handNext() {
           this.activeIndex=this.activeIndex<=(this.modata.WContent.nav.length-2)?this.activeIndex+1:this.activeIndex;
            if (this.swiperIns() && (this.realIndex+1)>=this.activeIndex) {
                this.swiperIns().slideNext()
            }
             
        },
        handToSlide(index) {
            this.activeIndex = index || 0
            if (this.swiperIns()) this.swiperIns().slideToLoop(index, 1000, false)
        }
    }
}
</script>

<style scoped lang="scss">
.van-sticky {
    position: relative;
    overflow: hidden;
}

.van-sticky .img {
    display: block;
    width: 100%;
    height: auto;
}

.swiper-container .swiper-wrapper .swiper-slide img {
    width: 100%;
    height: 100%;
}

.swipers3_arrow {
    border: none;
    outline: 0;
    padding: 0;
    margin: 0;
    height: 42px;
    width: 42px;
    cursor: pointer;
    -webkit-transition: .3s;
    transition: .3s;
    border-radius: 50%;
    background-color: rgba(31, 45, 61, .2);
    color: #FFF;
    position: absolute;
    top: 60px;
    z-index: 10;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    text-align: center;
    font-size: 18px;
}

.swipers3_arrow i {
    margin-top: 2px;
}

.swipers3_arrow:hover {
    background-color: #888;
}

.swipers3_arrow-not {
    background-color: rgba(31, 45, 61, .09) !important;
}

.swipers3_arrow-left {
    left: 25px;
}

.swipers3_arrow-right {
    right: 25px;
}

.viewItem {
    padding: 0 100px;
    position: relative;
}

.titleModule {
    padding: 40px 0 55px;
}

.slideWrap {
    margin: 0 0 50px;
    overflow: hidden;
    position: relative;
}

.slideWrap::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    height: 1px;
    background: #dfdfdf;
    bottom: 10px;
}

.slide-item {
    padding: 0 0 38px;
}

.slide-item.active .p_title {
    color: var(--active-color);
    font-weight: bold;
}

.slide-item .p_title {
    position: relative;
    margin: 0;
    transition: all ease 1s;
    padding: 0 15px;
    text-align: center;
    line-height: 1;
    color: #999;
    font-size: 33px;
    font-weight: 400;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    cursor: pointer;
}

.slide-item::after {
    content: '';
    position: absolute;
    bottom: 5px;
    left: 50%;
    transform: translateX(-50%);
    background: #ccc;
    border: 2px solid #ccc;
    width: 10px;
    height: 10px;
    border-radius: 100%;
    cursor: pointer;
}

.slide-item.active::after {
    background: #fff;
    border: 2px solid var(--active-color);
    width: 14px;
    height: 14px;
    bottom: 3px;
}

.HonorList {
    display: block;
    min-height: 130px;
    max-width: 96%;
    margin: auto;
    max-height: 64vh;
    overflow-y: auto;
    padding: 0px 20px;
}

.HonorList li {
    display: block;
    justify-content: space-between;
    position: relative;
    border-radius: 20px;
    overflow: hidden;
    margin-bottom: 25px;
}

.HonorList li:before {
    content: '';
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(0deg, #0047b5db 0%, #0450a100 50%, #ffffff33 100%);
    z-index: 1;
}

.HonorList li .honorText {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0px 35px;
    position: absolute;
    bottom: 25px;
    z-index: 2;
}

.HonorList li .honorImg {
    width: 100%;
}

.HonorList li .honorImg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 20px;
}

.HonorList li .honorText p.honorTitle {
    font-size: 28px;
    color: #fff;
    margin-bottom: 8px;
    font-weight: bold;
}

.HonorList li .honorText p.honorSumm {
    font-size: 16px;
    color: #fff;
    text-align: left;
}

.course2-module__markdown {
    padding: 20px 100px;
    line-height: 1.8;
    font-size: 16px;
    color: inherit;
}

.course2-module__edit-card {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 12px;
    margin-bottom: 12px;
    background: #fafafa;
}

.course2-module__edit-head {
    font-weight: bold;
    margin-bottom: 8px;
}

@media screen and (max-width: 1280px) and (min-width: 769px) {
    .slide-item {
        padding-bottom: 30px;
    }

    .slide-item .p_title {
        font-size: 30px;
    }

    .swipers3_arrow {
        width: 34px;
        height: 34px;
        top: 48px;
    }
}

@media screen and (max-width: 768px) {
    .viewItem {
        padding: 0;
    }

    .slide-item {
        padding-bottom: 28px;
    }

    .slide-item .p_title {
        font-size: 28px;
    }

    .slideWrap {
        width: calc(100% - 88px);
        margin: 0 auto 6px;
    }

    .swipers3_arrow {
        width: 30px;
        height: 30px;
        top: 48px;
    }

    .swipers3_arrow-left {
        left: 1px;
    }

    .swipers3_arrow-right {
        right: 1px;
    }

    .HonorList li {
        flex-direction: column;
    }

    .HonorList li .honorText,
    .HonorList li .honorImg {
        width: 100%;
        padding-right: 0%;
    }

    .HonorList li .honorImg {
        margin-top: 20px;
    }

    .HonorList li .honorSumm {
        margin-bottom: 10px;
    }
}
</style>
